import { render, staticRenderFns } from "./ExtendOtherNutrientsFolidAcid.vue?vue&type=template&id=50a82174&scoped=true"
import script from "./ExtendOtherNutrientsFolidAcid.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsFolidAcid.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsFolidAcid.vue?vue&type=style&index=0&id=50a82174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a82174",
  null
  
)

export default component.exports